const Transport = () => import(/* webpackChunkName: "Transport" */ "@/views/transport/Transport");
const Stops = () => import(/* webpackChunkName: "Stops" */ "@/views/transport/Stops");
const Platforms = () => import(/* webpackChunkName: "Platforms" */ "@/views/transport/Platforms");
const Schedules = () => import(/* webpackChunkName: "Schedules" */ "@/views/transport/Schedules");
const Guidelines = () => import(/* webpackChunkName: "Guidelines" */ "@/views/transport/Guidelines");
const FAQ = () => import(/* webpackChunkName: "FAQ" */ "@/views/transport/FAQ");

const transportRoutes = [
  {
    path: "transport",
    name: "Transport",
    redirect: {
      name: "Stops"
    },
    component: Transport,
    children: [
      {
        path: "stops",
        name: "Stops",
        component: Stops
      },
      {
        path: "platforms",
        name: "Platforms",
        component: Platforms
      },
      {
        path: "schedules",
        name: "Schedules",
        component: Schedules
      },
      {
        path: "guidelines",
        name: "Guidelines",
        component: Guidelines
      },
      {
        path: "faq",
        name: "FAQ",
        component: FAQ
      }
    ]
  }
];

export default transportRoutes;